module.exports = "<div class=\"footer\">\n    <p jhiTranslate=\"footer\">This is your footer</p>\n</div>\n<template ngbModalContainer></template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/footer/footer.component.html
// module id = 439
// module chunks = 0